var path = 'src/app/patients/family-history/family-history.html';
var html = "<h1 class=page-header>Family History <small>{{cohort.name}}</small></h1> <div family-history-component patient=patient cohort=cohort></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/family-history/family-history.html
 ** module id = 449
 ** module chunks = 0
 **/